import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Nav, Navbar, NavDropdown, Container, Modal } from 'react-bootstrap';
import { IoCallOutline } from "react-icons/io5";
import Dropdown from "react-bootstrap/Dropdown";
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';
import Login from '../components/auth/login/Login';
import { Icon } from '@iconify/react';
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios';
import { getCookie } from '../components/auth/login/GetCookie';
import Cookies from 'js-cookie';
// import logo from '../Assets/Images/logo.png'
import logo from '../Assets/Images/Gravinora.png'


const Header = () => {
    const [loginopen, setloginopen] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [show, setShow] = useState(false);
    const navigate = useNavigate();
    const [notifications, setNotifications] = useState([]);
    const [readNotifications, setReadNotifications] = useState(new Set());
    const [showDropdown, setShowDropdown] = useState(false);
    const handleClose = () => setShow(false);


    // Check login status from local storage
    useEffect(() => {
        // const token = localStorage.getItem('token');
        const token = getCookie('token');
        setIsLoggedIn(!!token); // Check if token exists
        fetchnotification();
        // const interval = setInterval(fetchnotification, 5000); // Poll every 5s
        // return () => clearInterval(interval); // Cleanup on unmount
    }, []);


    // const markAsRead = (notificationId) => {
    //     if (!notificationId) {
    //         console.error("Invalid notification ID");
    //         return;
    //     }

    //     setReadNotifications((prev) => {
    //         const updatedRead = new Set(prev);
    //         updatedRead.add(notificationId);

    //         localStorage.setItem("readNotifications", JSON.stringify([...updatedRead])); // Store as an array
    //         return updatedRead;
    //     });

    //     console.log(`Notification ${notificationId} marked as read.`);
    // };
    const markAsRead = async (notificationId) => {
        const notification = notifications.find((notif) => notif.notificationId === notificationId);

        if (!notification) {
            toast.error("Notification not found!");
            return;
        }

        if (notification.read) {
            toast.error("Already marked as read.");
            return;
        }

        try {
            // const token = localStorage.getItem('token');
            const token = getCookie("token");
            await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/notifications/${notificationId}/mark-read`,
                {}, // Assuming no body is required
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            // Update local state after successful API call
            setNotifications((prev) =>
                prev.map((notif) =>
                    notif.notificationId === notificationId ? { ...notif, read: true } : notif
                )
            );

            setReadNotifications((prev) => {
                const updatedRead = new Set(prev).add(notificationId);
                // localStorage.setItem("readNotifications", JSON.stringify([...updatedRead]));
                Cookies.set("readNotifications", JSON.stringify([...updatedRead]));
                return updatedRead;
            });

            toast.success("Notification marked as read!");
        } catch (error) {
            console.error("Error marking notification as read:", error);
            toast.error("Failed to mark notification as read.");
        }
    };

    const fetchnotification = async () => {
        // const token = localStorage.getItem('token');
        const token = getCookie("token");

        // if (!token) {
        //     toast.error("Invalid token");
        //     return;
        // }



        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BACKEND_URL}/api/v1/notifications`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            const allNotifications = response.data;

            // Filter only INQUIRY_REPLY notifications
            const filteredNotifications = allNotifications.filter(
                (notif) => notif.notificationType === "INQUIRY_REPLY"
            );



            if (Array.isArray(filteredNotifications)) {
                console.log("Notification IDs:", filteredNotifications.map((notif) => notif.notificationId));
                console.log("Notification status:", filteredNotifications.map((notif) => notif.read));
            }
            setNotifications(filteredNotifications);

        } catch (error) {
            console.error("Error Fetching Notification:", error);
        } finally {
        }
    };

    // Function to open login modal
    function handleOpenLogin() {
        setloginopen(true);
    }

    // Function to close login modal
    const handleCloseLogin = () => setloginopen(false);

    const [showLogoutModal, setShowLogoutModal] = useState(false);

    // Cookie configuration options
    const cookieOptions = {
        //secure: process.env.NODE_ENV === 'production', // Secure in production
        //sameSite: 'strict',
        sameSite: 'Lax',   // ✅ best choice for HTTP
        path: '/',
        expires: 1 // 1 day expiration
    };

    // Function to handle user logout
    const handleLogout = () => {
        // Remove all auth cookies
        Cookies.remove('token', cookieOptions);
        Cookies.remove('roles', cookieOptions);
        Cookies.remove('user', cookieOptions);
        // Determine where user logged in from
        const loginOrigin = Cookies.get("loginOrigin");
        Cookies.remove("loginOrigin");
        setIsLoggedIn(false);
        console.log("logout successfully == header")
        toast.success("Logout Successfully!", { duration: 10000 })
        window.location.reload();
        const BASE_URL = process.env.REACT_APP_ADMIN_lOGOUT_URL
        const BASE_URL_BUYER = process.env.REACT_APP_BUYER_URL
        // Redirect
        if (loginOrigin === "admin") {
            window.location.href = BASE_URL; //ADMIN
        } else {
            window.location.href = BASE_URL_BUYER; //BUYER
        }

    };



    return (
        <>
            <Navbar expand="lg" className=" px-5 fixed-top w-100  d-lg-inline-block d-none"
                style={{ backgroundColor: '#FDC400' }}
            >
                <Toaster position='top-right' reverseOrder={false} />
                <Container fluid>
                    <Navbar.Brand as={Link} to="/" onClick={() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }}>
                        <div className="d-flex align-items-center justify-content-center">
                            <div >
                                <img src={logo} alt="Logo" style={{
                                    height: '52px', width: '172px',

                                }} />
                            </div>
                            {/* <span className="ms-2 fw-bold logo-text">VANGUARD</span> */}
                        </div>
                    </Navbar.Brand>

                    <Navbar.Collapse id="navbarScroll">
                        <Nav className="ms-auto d-flex align-items-center">
                            {/* Contact Info */}
                            <div className="d-flex align-items-center contact-link me-3" >
                                <IoCallOutline className="me-2" fontSize={24} />
                                +12345 67890
                            </div>
                            {/* Notification on large screen */}
                            {isLoggedIn && (
                                <Navbar.Collapse id="basic-navbar-nav">
                                    <div className=" notification-Icon me-4">
                                        <div onClick=

                                            {() => setShowDropdown(!showDropdown)}
                                        >
                                            <Icon
                                                icon="mdi:bell-outline"
                                                className="fs-4 cursor-pointer position-relative"

                                            />

                                            {notifications.some(n => !n.read) && (
                                                <span className="">
                                                    <Icon icon="icon-park-outline:dot" className="noti-no" />
                                                </span>
                                            )}

                                        </div>


                                        {showDropdown && (
                                            <div
                                                className="dropdown-menu dropdown-menu-end show p-2 shadow"
                                                style={{
                                                    width: "300px",
                                                    position: "absolute",
                                                    right: 150,
                                                    top: "76px",
                                                    zIndex: 1000,
                                                }}
                                            >
                                                <button className='view-btn float-end px-2'
                                                    onClick={() => {
                                                        setShowDropdown(false);
                                                        navigate('/notification')
                                                    }}
                                                    style={{ fontSize: '14px', cursor: 'pointer' }}>
                                                    View All
                                                    <Icon icon='weui:arrow-filled' className='fs-4 ps-1' />
                                                </button>
                                                <h6 className="fw-bold">Notifications</h6>
                                                <ul className="list-unstyled m-0">
                                                    {notifications.length > 0 ? (
                                                        notifications.map((n, index) => (
                                                            <li
                                                                key={index}
                                                                className="d-flex align-items-start p-2 cursor-pointer"
                                                                onClick={() => {
                                                                    if (!readNotifications.has(n.notificationId)) {
                                                                        markAsRead(n.notificationId);
                                                                    }
                                                                    setShowDropdown(false);
                                                                }}
                                                            >
                                                                {/* Icon */}
                                                                <div className="me-2">
                                                                    <div
                                                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                                                        style={{
                                                                            width: "40px", height: "40px",
                                                                            background: '#f5f1b8ff'
                                                                        }}
                                                                    >
                                                                        {n.notificationType === "NEW_PRODUCT" ? (
                                                                            <Icon icon='ph:package' className="fs-5" style={{ color: '#371300', backgroundColor: '#E7FAFF' }} />

                                                                        ) : (
                                                                            <Icon icon='carbon:document' className=" fs-5" style={{ color: '#371300', backgroundColor: '#E7FAFF' }} />
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                {/* Notification Content */}
                                                                <div className="w-100 ">

                                                                    <p
                                                                        className="msg-title m-0"
                                                                        style={{
                                                                            fontWeight: n.read ? "500" : "600",
                                                                            color: n.read ? "#371300" : "#303030",
                                                                        }}
                                                                    >
                                                                        {n.notificationType === "NEW_PRODUCT" ? "New Product Added!" : "New Enquiry Received!"}
                                                                    </p>


                                                                    <p className="msg-Noti m-0">{n.message}</p>
                                                                </div>
                                                            </li>
                                                        ))
                                                    ) : (
                                                        <p className="text-muted text-center">No notifications</p>
                                                    )}
                                                </ul>

                                            </div>
                                        )}
                                    </div>
                                </Navbar.Collapse>
                            )}

                            {/* Conditional Rendering for Login/Profile */}
                            {isLoggedIn ? (
                                <NavDropdown
                                    title={
                                        <span className="d-flex profile-Name align-items-center">
                                            <Icon icon="ic:outline-account-circle" className="fs-5 me-2" style={{ color: "#606060" }} />
                                            Profile
                                            <Icon icon="icon-park-outline:down" className="fs-5 pt-1" style={{ color: "#707070" }} />
                                        </span>
                                    }
                                    id="profile-dropdown"
                                    className="profile-dropdown  border rounded-pill px-1"
                                    align="end"
                                    show={show} // Control dropdown visibility
                                    onToggle={(isOpen) => setShow(isOpen)} // Ensure correct dropdown toggle behavior
                                    style={{ backgroundColor: '#FFFFFF' }}
                                >
                                    <NavDropdown.Item
                                        as={Link}
                                        to="/profile"
                                        className="fs-6 fw-normal"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setShow(false);  // Manually close the dropdown
                                            document.querySelector(".profile-dropdown .dropdown-menu").classList.remove("show"); // Ensure it closes
                                            navigate("/profile");
                                        }}
                                    >
                                        Account
                                        <Icon icon="mingcute:right-line" className="fs-5 float-end" />
                                    </NavDropdown.Item>
                                    <NavDropdown.Divider />
                                    <NavDropdown.Item
                                        className="text-danger fs-6 fw-normal"
                                        onClick={(e) => {

                                            setShowLogoutModal(true); // Show confirmation modal
                                            e.preventDefault();  // Prevent default behavior
                                            handleClose();  // Close dropdown

                                        }}
                                    >
                                        Logout
                                        <Icon icon="mingcute:right-line" className="fs-5 text-danger float-end" />
                                    </NavDropdown.Item>
                                </NavDropdown>
                            ) : (
                                <>
                                    {/* Login and Register Buttons */}
                                    <Button className="me-3 px-4 login-btn rounded-pill"
                                        onClick={handleOpenLogin}>
                                        Login
                                    </Button>
                                    <Link to='/register'>
                                        <Button className="create-btn rounded-pill px-3">
                                            Create an account
                                        </Button>
                                    </Link>
                                </>
                            )}

                        </Nav>
                    </Navbar.Collapse>
                </Container>

                {/* Login Modal */}
                {loginopen && <Login onClose={handleCloseLogin} loginopen={loginopen} />}
            </Navbar>
            {showLogoutModal && (
                <div
                    className="modal show d-block d-flex justify-content-center align-items-center"
                    style={{
                        boxShadow: '0px 4px 6px 0px #00000026',
                        background: '#000000B2',
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100vw',
                        height: '100vh',
                        zIndex: 1050,
                    }}
                >
                    <div className="modal-dialog modal-sm modal-md modal-lg modal-xl modal-xxl w-100 mx-3 mx-sm-5" style={{ maxWidth: '600px' }}>
                        <div className="modal-content pt-4">
                            <div className="d-flex justify-content-end px-3">
                                <Icon
                                    icon="material-symbols-light:close"
                                    className="close-btn fs-5"
                                    onClick={() => setShowLogoutModal(false)}
                                    style={{ cursor: 'pointer' }}
                                />
                            </div>
                            <h5 className="pt-4 fw-bold fs-5 px-4 text-center">Logout Confirmation</h5>
                            <p className="px-4 fw-normal fs-6 text-center" style={{ color: '#606060' }}>
                                Are you sure you want to logout?
                            </p>
                            <div className="d-flex justify-content-center align-items-center gap-3 gap-md-4 mt-2 mb-5 flex-wrap">
                                <button
                                    className="rounded-5 border cancelbtn px-4 py-2 px-md-5"
                                    onClick={() => setShowLogoutModal(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="px-4 py-2 px-md-5 rounded-5 border"
                                    style={{
                                        background: '#371300',
                                        color: '#FFFFFF',
                                    }}
                                    onClick={handleLogout}
                                >
                                    Yes, Logout
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}


        </>


    );
};

export default Header;

